import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Instagram, Facebook, Youtube, Mail, MapPin } from 'lucide-react';
import Logo from './Logo';
import { useTexts } from '../context/TextsContext';

// Logos partenaires officiels Citytoon (contenu réel, hébergé sur citytoon.org)
const PARTNERS = [
  'https://citytoon.org/wp-content/uploads/2023/10/logo_na_vertical_QUADRI_2019-808x1067.jpg',
  'https://citytoon.org/wp-content/uploads/2023/03/LRTE_LOGO-QUADRI-ON.jpg',
  'https://citytoon.org/wp-content/uploads/2023/10/communaute_d_agglomeration_de_la_rochelle-svg-808x240.png',
  'https://citytoon.org/wp-content/uploads/2023/11/1200px-Ministere-Education-Nationale-Jeunesse-Sports.svg_-808x842.png',
  'https://citytoon.org/wp-content/uploads/2023/10/logo-festivalcoree.png',
  'https://citytoon.org/wp-content/uploads/2023/10/6213ca21ece6e962c414f87a_LaRochelleTechnopole.png',
];

const Footer = () => {
  const { t } = useTexts();
  return (
    <footer className="mt-20 bg-[#1c130f] text-white/80">
      <div className="max-w-7xl mx-auto px-4 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="space-y-4">
            <Logo />
            <p className="text-sm text-white/60 max-w-xs">
              {t('footer_tagline', 'Le webtoon didactique au service du patrimoine, de l’histoire et des territoires.')}
            </p>
            <div className="flex gap-2 pt-1">
              {[Linkedin, Instagram, Facebook, Youtube].map((Icon, i) => (
                <a key={i} href="https://www.youtube.com/channel/UCQy5OVfMCOYSKtuRqQQ22Ag" target="_blank" rel="noreferrer"
                   className="w-9 h-9 rounded-full bg-white/10 hover:bg-primary flex items-center justify-center transition-colors">
                  <Icon className="w-4 h-4 text-white" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-display font-600 text-white mb-4">Explorer</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/catalogue" className="hover:text-secondary transition-colors">Explorer les webtoons</Link></li>
              <li><Link to="/auteurs" className="hover:text-secondary transition-colors">Auteurs et autrices</Link></li>
              <li><Link to="/apropos" className="hover:text-secondary transition-colors">À propos</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-600 text-white mb-4">Contact</h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-primary" /> {t('contact_email', 'contact@citytoon.org')}</li>
              <li className="flex items-center gap-2"><MapPin className="w-4 h-4 text-primary" /> {t('contact_address', 'La Rochelle, France')}</li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-600 text-white mb-4">Ils soutiennent Citytoon</h4>
            <div className="grid grid-cols-3 gap-2">
              {PARTNERS.slice(0, 6).map((p, i) => (
                <div key={i} className="bg-white rounded-lg p-1.5 flex items-center justify-center h-12">
                  <img src={p} alt="partenaire" className="max-h-full max-w-full object-contain" loading="lazy" />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-white/50">
          <p>© {new Date().getFullYear()} Citytoon.org — Tous droits réservés.</p>
          <p>Lauréat Culture Tourisme &amp; Numérique 2022 – Région Nouvelle-Aquitaine</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
